import { createWorkflowContext } from './create'

export const workflowContexts = {
  create: createWorkflowContext,
}
